import styled from '@emotion/styled';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';

function NewFaq(props: BaseMsgProps) {
  const { newFaqContent } = props.raw;

  if (!newFaqContent) {
    return <></>;
  }

  const { opening, categories } = newFaqContent;

  return (
    <MessageExtendComplex
      {...props}
      content={
        <Container>
          <div>{opening}</div>
          <ul>
            {categories.map(({ title }) => (
              <li>{title}</li>
            ))}
          </ul>
        </Container>
      }
    />
  );
}

const Container = styled.div`
  max-width: 450px;
  border-radius: 4px;
  background: var(--fett-bg-panel);
  > div {
    padding: 8px 12px;
    border-bottom: solid 1px var(--fett-border-default);
  }
  > ul {
    margin: 0;
    padding: 0 12px;
    list-style: none;
    > li {
      padding: 8px 0;
      color: var(--fett-text-tertiary);
      & + li {
        border-top: solid 1px var(--fett-border-default);
      }
    }
  }
`;

export default NewFaq;
